import { Link } from 'react-router'
import { ChainRail, Reveal, Section, SectionHeading } from '@/components/primitives'

const STAGES = [
  'Come in',
  'One record',
  'Your rules',
  'Waiting work',
  'Talk',
  'Finish',
  'Result',
  'See it',
]

export function OperatingChain() {
  return (
    <Section labelledBy="chain-heading" className="bg-base-900/40">
      <Reveal>
        <SectionHeading
          id="chain-heading"
          title="Stop running the business across twelve tools."
          copy="A lead comes in. It becomes one record. Your rules send it to the right person. Your team works it. Leaders see what happened, and what should happen next."
        />
      </Reveal>

      <Reveal delay={80}>
        <div className="mx-auto mt-10 max-w-4xl text-center">
          <div className="flex justify-center">
            <ChainRail items={STAGES} ariaLabel="Operating chain from intake to visibility" />
          </div>
          <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-ink-mute">
            Point tools optimize a step. TLDNXS owns the chain.
          </p>
          <Link to="/platform" className="btn-ghost mt-5 px-0">
            See how the platform runs it →
          </Link>
        </div>
      </Reveal>
    </Section>
  )
}
